var forIn = require('./forIn');

    /**
     * return a list of all enumerable properties that have function values
     */
    function functions(obj){
        var keys = [];
        forIn(obj, function(val, key){
            if (typeof val === 'function'){
                keys.push(key);
            }
        });
        return keys.sort();
    }

    module.exports = functions;





//////////////////
// WEBPACK FOOTER
// ./~/mout/object/functions.js
// module id = 711
// module chunks = 0 1 2